import axios from "axios"

export const LeaderboardService = {

    getCurrentLeaderboard: async token => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/leaderboard`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return response.data
    }
}